// src/pages/TentangKami.jsx
import React, { useEffect } from 'react'; // Import useEffect untuk SEO Meta Tags

const TentangKami = () => {
  useEffect(() => {
    // --- SEO Meta Tags untuk Halaman Tentang Kami ---
    document.title = "Tentang Solusi IoT Cerdas: Visi Kami untuk Kemajuan Indonesia";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Pelajari lebih lanjut tentang Solusi IoT Cerdas, visi kami dalam mewujudkan Indonesia yang lebih cerdas, efisien, dan berkelanjutan melalui inovasi teknologi IoT. Kenali tim ahli dan nilai-nilai inti perusahaan kami.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "Solusi IoT Cerdas, tentang kami, visi misi IoT Indonesia, perusahaan teknologi Indonesia, inovasi digital, tim IoT ahli, nilai perusahaan, kemajuan IoT Indonesia");

    // Open Graph Tags (untuk media sosial)
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) { ogTitle = document.createElement('meta'); ogTitle.setAttribute('property', 'og:title'); document.head.appendChild(ogTitle); }
    ogTitle.setAttribute('content', "Tentang Solusi IoT Cerdas: Visi Kami untuk Kemajuan Indonesia");

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) { ogDescription = document.createElement('meta'); ogDescription.setAttribute('property', 'og:description'); document.head.appendChild(ogDescription); }
    ogDescription.setAttribute('content', "Pelajari lebih lanjut tentang Solusi IoT Cerdas, visi kami dalam mewujudkan Indonesia yang lebih cerdas, efisien, dan berkelanjutan melalui inovasi teknologi IoT. Kenali tim ahli dan nilai-nilai inti perusahaan kami.");

    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) { ogType = document.createElement('meta'); ogType.setAttribute('property', 'og:type'); document.head.appendChild(ogType); }
    ogType.setAttribute('content', "website");

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) { ogUrl = document.createElement('meta'); ogUrl.setAttribute('property', 'og:url'); document.head.appendChild(ogUrl); }
    ogUrl.setAttribute('content', "https://www.solusiiotcerdas.id/tentang-kami"); // Ganti dengan URL domain Anda untuk halaman ini

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) { ogImage = document.createElement('meta'); ogImage.setAttribute('property', 'og:image'); document.head.appendChild(ogImage); }
    ogImage.setAttribute('content', "https://via.placeholder.com/1200x630/4682B4/FFFFFF?text=Solusi+IoT+Cerdas+Tentang+Kami"); // Ganti dengan URL gambar relevan (Logo/Tim/etc.)

    // Twitter Card Tags
    let twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) { twitterCard = document.createElement('meta'); twitterCard.setAttribute('name', 'twitter:card'); document.head.appendChild(twitterCard); }
    twitterCard.setAttribute('content', "summary_large_image");

    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (!twitterImage) { twitterImage = document.createElement('meta'); twitterImage.setAttribute('name', 'twitter:image'); document.head.appendChild(twitterImage); }
    twitterImage.setAttribute('content', "https://via.placeholder.com/1200x630/4682B4/FFFFFF?text=Solusi+IoT+Cerdas+Tentang+Kami"); // Ganti dengan URL gambar relevan

    return () => {
      // Cleanup opsional
    };
  }, []);

  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Hero Section Tentang Kami */}
        <section className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700 dark:text-blue-400 leading-tight mb-4">
            Tentang Solusi IoT Cerdas
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300">
            Membangun masa depan yang terhubung melalui inovasi Internet of Things untuk Indonesia yang lebih maju.
          </p>
        </section>

        {/* Bagian Visi & Misi - Ditingkatkan agar lebih menarik dan menyala */}
        <section className="mb-16 bg-gradient-to-br from-blue-50 dark:from-gray-700 to-purple-50 dark:to-gray-800 p-8 rounded-lg shadow-xl transform transition-all duration-500 hover:scale-[1.01] hover:shadow-2xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="p-4 bg-white dark:bg-gray-900 rounded-lg shadow-lg">
              <h2 className="text-3xl font-extrabold text-indigo-700 dark:text-indigo-400 mb-4 animate-fade-in-down">✨ Visi Kami</h2>
              <p className="text-gray-800 dark:text-gray-200 text-lg leading-relaxed">
                <strong className="text-purple-600 dark:text-purple-400">Mewujudkan Indonesia yang lebih cerdas, efisien, dan berkelanjutan</strong> melalui penyediaan solusi IoT inovatif yang transformatif. Kami berkomitmen untuk <strong className="text-blue-600 dark:text-blue-400">memberdayakan masyarakat dan berbagai sektor di seluruh Nusantara</strong> dengan teknologi terdepan, mendorong <strong className="text-green-600 dark:text-green-400">kemajuan digital bangsa</strong> demi masa depan yang lebih baik.
              </p>
            </div>
            <div className="p-4 bg-white dark:bg-gray-900 rounded-lg shadow-lg">
              <h2 className="text-3xl font-extrabold text-indigo-700 dark:text-indigo-400 mb-4 animate-fade-in-down">🎯 Misi Kami</h2>
              <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 text-lg space-y-3">
                <li><strong className="text-purple-600 dark:text-purple-400">Mengembangkan dan menyediakan</strong> teknologi IoT terdepan dan terintegrasi yang relevan dengan kebutuhan pasar Indonesia.</li>
                <li><strong className="text-blue-600 dark:text-blue-400">Membangun solusi kustom</strong> yang adaptif dan memberikan nilai tambah nyata bagi bisnis, UMKM, dan masyarakat.</li>
                <li><strong className="text-green-600 dark:text-green-400">Mendorong inovasi berkelanjutan</strong> dan penelitian di bidang IoT yang berorientasi pada solusi permasalahan lokal.</li>
                <li><strong className="text-red-600 dark:text-red-400">Memberikan dukungan teknis</strong> dan layanan purna jual yang profesional dan responsif kepada setiap klien.</li>
                <li><strong className="text-yellow-600 dark:text-yellow-400">Meningkatkan kesadaran dan edukasi</strong> tentang potensi serta manfaat IoT untuk pembangunan ekonomi dan kualitas hidup di Indonesia.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Bagian Nilai-nilai Perusahaan */}
        <section className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Nilai-Nilai Kami</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl text-blue-500 dark:text-blue-300 mb-4">💡</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Inovasi</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Kami terus berinovasi untuk memberikan solusi IoT terbaik dan paling relevan, beradaptasi dengan dinamika kebutuhan Indonesia.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl text-green-500 dark:text-green-300 mb-4">🤝</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Kolaborasi</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Kami percaya pada kekuatan kerjasama dengan klien, mitra, dan komunitas untuk mencapai tujuan bersama dalam ekosistem digital.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl text-yellow-500 dark:text-yellow-300 mb-4">✅</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Keunggulan</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                Kami berkomitmen untuk memberikan kualitas, keandalan, dan performa terbaik dalam setiap produk dan layanan kami.
              </p>
            </div>
          </div>
        </section>

        {/* Bagian Tim Kami - Diperbarui dengan semua ikon orang dan penambahan Sarah Meutia */}
        <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Tim Kami</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {/* Anggota Tim 1: Budi Prasetyo Nugroho (CEO & Founder) */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Budi Prasetyo Nugroho</h3>
              <p className="text-blue-600 dark:text-blue-400 text-sm font-medium">CEO & Founder</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Pemimpin visioner dengan pengalaman 10+ tahun di IoT.</p>
            </div>
            {/* Anggota Tim 2: Bayu Santoso (System Analyst) */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-green-100 dark:bg-green-800 text-green-700 dark:text-green-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Bayu Santoso</h3>
              <p className="text-green-600 dark:text-green-400 text-sm font-medium">System Analyst</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Ahli dalam analisis dan perancangan sistem yang efisien.</p>
            </div>
            {/* Anggota Tim 3: Danial Makarim (Marketing Officer) */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-purple-100 dark:bg-purple-800 text-purple-700 dark:text-purple-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Danial Makarim</h3>
              <p className="text-purple-600 dark:text-purple-400 text-sm font-medium">Marketing Officer</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Berdedikasi dalam membangun jangkauan pasar dan brand.</p>
            </div>
            {/* Anggota Tim 4: Rinaldi Pahlevi (Marketing Officer) */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-red-100 dark:bg-red-800 text-red-700 dark:text-red-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Rinaldi Pahlevi</h3>
              <p className="text-red-600 dark:text-red-400 text-sm font-medium">Marketing Officer</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Fokus pada strategi pemasaran dan hubungan klien.</p>
            </div>
            {/* Anggota Tim 5: Sarah Meutia (Marketing Officer) - BARU */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-pink-100 dark:bg-pink-800 text-pink-700 dark:text-pink-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Sarah Meutia</h3>
              <p className="text-pink-600 dark:text-pink-400 text-sm font-medium">Marketing Officer</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Bertanggung jawab dalam kampanye pemasaran dan promosi.</p>
            </div>
            {/* Anggota Tim 6: Zulhilmi Bangkit (Advisor) */}
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center rounded-full bg-yellow-100 dark:bg-yellow-800 text-yellow-700 dark:text-yellow-300 text-5xl mb-4 shadow-md">👤</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Zulhilmi Bangkit</h3>
              <p className="text-yellow-600 dark:text-yellow-400 text-sm font-medium">Advisor</p>
              <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">Memberikan panduan strategis dan wawasan industri.</p>
            </div>
          </div>
        </section>

        {/* Bagian Perjalanan Kami / Milestones - Diperbarui dengan Depot Air Cerdas */}
        <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Perjalanan Kami untuk Indonesia</h2>
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 text-blue-500 dark:text-blue-300 text-2xl mr-4">📅</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2016: Pendirian Solusi IoT Cerdas di Depok</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Didirikan di Depok, Jawa Barat, dengan visi awal untuk membawa inovasi IoT ke sektor agrikultur Indonesia.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 text-green-500 dark:text-green-300 text-2xl mr-4">🌱</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2018: Peluncuran Solusi Smart Farming Lokal</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Merilis produk Smart Farming pertama yang dirancang khusus untuk kebutuhan petani dan kondisi lahan di Indonesia, membantu peningkatan hasil panen.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 text-purple-500 dark:text-purple-300 text-2xl mr-4">🏠</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2020: Ekspansi ke Otomatisasi Smart Home untuk Keluarga Indonesia</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Memperluas layanan ke sektor rumah pintar, menyediakan sistem otomatisasi dan keamanan yang meningkatkan kenyamanan dan efisiensi energi rumah tangga Indonesia.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 text-red-500 dark:text-red-300 text-2xl mr-4">💧</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2022: Inovasi Smart Water Monitoring untuk Efisiensi Air Nasional</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Mengembangkan sistem pemantauan air cerdas, berkontribusi pada upaya konservasi air dan efisiensi penggunaan air di berbagai properti komersial dan residensial di Indonesia.
                </p>
              </div>
            </div>
            {/* MILESTONE BARU: Depot Air Minum Cerdas */}
            <div className="flex items-start">
              <div className="flex-shrink-0 text-indigo-500 dark:text-indigo-300 text-2xl mr-4">🚰</div> {/* Icon keran air */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2023: Pengembangan Solusi Depot Air Cerdas</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Memperkenalkan inovasi depot air cerdas berbasis IoT untuk memantau kualitas air, mengelola stok, dan otomatisasi pembayaran, mendukung penyediaan air bersih yang lebih higienis dan efisien bagi masyarakat.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 text-yellow-500 dark:text-yellow-300 text-2xl mr-4">🌐</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">2024: Kemitraan Strategis dan Jangkauan Nasional</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Menjalin kerjasama dengan institusi pendidikan dan industri lokal untuk mempercepat adopsi IoT, serta memperluas jangkauan layanan ke seluruh provinsi di Indonesia.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Bagian CTA untuk Hubungi Kami */}
        <section className="text-center bg-blue-600 dark:bg-blue-900 text-white p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold mb-4">Mari Bangun Masa Depan Cerdas Bersama Indonesia</h2>
          <p className="text-lg mb-6">
            Kami siap menjadi mitra Anda dalam mewujudkan proyek IoT yang inovatif dan relevan dengan kemajuan bangsa.
          </p>
          <button
            onClick={() => window.location.href = '/kontak/formulir'} // Menggunakan window.location untuk navigasi langsung
            className="bg-white text-blue-600 dark:bg-blue-200 dark:text-blue-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
          >
            Hubungi Tim Kami
          </button>
        </section>

      </div>
    </div>
  );
};

export default TentangKami;